import React from 'react';
import QueryString from 'qs';

import { useStore } from '@src/models';
import { useDebouncedFunction, useUpdateEffect } from 'src/hooks';

const updateSearchQueryString = ({ push, searchText, newQsObj }) => {
  // TODO UPDATED TWICE
  const newQs = QueryString.stringify({ ...newQsObj, ...{ search_text: searchText?.trim() || undefined } });
  push({
    search: newQs
  });
};

export const useSearchFilter = (): [string, (string) => void] => {
  const {
    routerStore: {
      push,
      location: { search }
    }
  } = useStore();
  const newQsObj = QueryString.parse(search, { ignoreQueryPrefix: true });

  const [searchText, setSearchText] = React.useState(newQsObj.search_text || '');

  const debouncedSetFilter = useDebouncedFunction(updateSearchQueryString, 750);

  // update scope in search query this will trigger refetch jobs
  useUpdateEffect(() => {
    debouncedSetFilter({ push, searchText, newQsObj });
  }, [searchText, searchText]);
  useUpdateEffect(() => {
    setSearchText(newQsObj.search_text || '');
  }, [search]);

  return [searchText, setSearchText];
};
